/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { metaAdCampaignDetailsDataStatusSchema } from './MetaAdCampaignDetailsDataStatusSchema'

export const metaAdCampaignDetailsDataSchema = z.object({
	metaUrl: z.string().nullable(),
	facebookId: z.string().nullable(),
	status: metaAdCampaignDetailsDataStatusSchema,
})

export type MetaAdCampaignDetailsDataSchema = z.infer<typeof metaAdCampaignDetailsDataSchema>
